var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconQuestion = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "-0.052 0 200.052 200",
    viewBox: "-0.052 0 200.052 200",
    role: "presentation",
    "aria-hidden": "true",
    width: 40,
    height: 40,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.4 137.7c-5.1 0-9.1 4-9.1 9.1 0 5 4.1 9.1 9.1 9.1 5.1 0 9.3-4.1 9.3-9.1 0-5.1-4.1-9.1-9.3-9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7 39.9c-17.5 0-25.6 12.9-29 18.4l-.3.5c-.7 1.3-2.1 3.6 1.1 5.8l1.9 1.3c2.7 1.8 4.3.6 5.4-.4.4-.4.9-1.1 1.4-2 2.4-3.8 7.4-11.8 20.5-11.8 12.9 0 17.5 9.7 17.5 18.8 0 8.5-6.4 13.7-13.2 19.3-7 5.7-14.1 11.5-14.1 21.1v10.6c0 2.6 1.6 4.4 4 4.4h3.5c2.6 0 4.2-1.7 4.2-4.4v-10.4c0-4.6 4.6-8.3 9.9-12.5 7.8-6.2 17.6-13.9 17.6-28.7-.2-14.4-9.7-30-30.4-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 0C44.9 0 0 44.9 0 100c0 16.3 4.1 32.5 11.8 47L.2 183.2c-.6 1.8-.1 3.7 1.2 5.1 1.3 1.4 3.2 1.9 5 1.4l34.1-9.3C57.9 193.2 78.4 200 100 200c55.1 0 100-44.9 100-100S155.1 0 100 0zm0 189.8c-20.1 0-39.2-6.6-55.2-19.1-.9-.7-2-1.1-3.2-1.1-.5 0-.9.1-1.4.2l-27.4 7.5 9.3-29.3c.4-1.4.3-2.8-.4-4.1-7.6-13.4-11.5-28.6-11.5-44 0-49.5 40.3-89.8 89.8-89.8s89.8 40.3 89.8 89.8c0 49.6-40.3 89.9-89.8 89.9z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconQuestion, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_question.64747c18.svg";
export { ForwardRef as ReactComponent };